import { ga, outbrain, taboola } from 'js/analytics/adapters'

export const trackAppStoreButtonClick = ({ type }) => {
  ga.track('app_store_buttons_click', {
    type,
  })
  outbrain.track('Add to cart')
  taboola.track('add_to_cart')
}
